module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-e2e-not-found"
  }, [(_vm.type == 'image') ? [_c('div', {
    staticClass: "e2e-not-found-container"
  }, [_c('div', [(_vm.type == 'image') ? _c('img', {
    style: ('height: ' + _vm.height + ';'),
    attrs: {
      "src": _vm.imgTableSrc,
      "alt": "",
      "srcset": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "color": "#999"
    }
  }, [(_vm.$slots.default) ? _c('span', [_vm._t("default")], 2) : _c('span', [_vm._v(_vm._s(_vm.$t('system.no_data')))])])])] : _vm._e(), _vm._v(" "), (_vm.type == 'text') ? [_c('div', {
    staticClass: "e2e-not-found-container"
  }, [_vm._v(_vm._s(_vm.$t('system.no_data')))])] : _vm._e()], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ae5c7cfe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae5c7cfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/NoDataFound.vue
// module id = 1599
// module chunks = 7